import { render, staticRenderFns } from "./UserDropDown.vue?vue&type=template&id=4bff6cc6"
import script from "./UserDropDown.vue?vue&type=script&lang=js"
export * from "./UserDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports